var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M138.88,65.06a1.5,1.5,0,0,0-1.64-.54L94.6,77.44a1.5,1.5,0,0,0-1,1.89,1.59,1.59,0,0,0,.52.73l6.41,4.57A60.19,60.19,0,0,1,81.49,95.18,60,60,0,0,1,62.4,84.67l6.4-4.61a1.47,1.47,0,0,0,.61-1.46,1.49,1.49,0,0,0-1-1.2L25.73,64.55a1.5,1.5,0,0,0-1.64.51,1.52,1.52,0,0,0,0,1.73L43.52,96.24a1.56,1.56,0,0,0,1,.65,1.54,1.54,0,0,0,1.14-.26l5.73-4.08a55.78,55.78,0,0,0,24.66,6,52.27,52.27,0,0,0,5.46-.29,52.22,52.22,0,0,0,5.45.29,55.78,55.78,0,0,0,24.66-6l5.72,4.08a1.48,1.48,0,0,0,2.07-.32l0-.07,19.46-29.42A1.52,1.52,0,0,0,138.88,65.06Zm-87,24.37a1.34,1.34,0,0,0-.68-.16,1.43,1.43,0,0,0-.87.28l-5.11,3.74L28.84,68.63l35.74,10.8-5.52,3.94a1.47,1.47,0,0,0-.63,1.16A1.56,1.56,0,0,0,59,85.74a68,68,0,0,0,15.14,9.77,53.49,53.49,0,0,1-22.2-6.05Zm65.89,3.83-5.2-3.71a1.47,1.47,0,0,0-1.55-.12,53.45,53.45,0,0,1-22.19,6A68.4,68.4,0,0,0,104,85.71a1.53,1.53,0,0,0,.53-1.21,1.47,1.47,0,0,0-.63-1.16L98.36,79.4,134.1,68.6Z","key":1})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=Icon!./src/components/icons/homeowners-icon-flexible.svg
// module id = 290
// module chunks = 0